import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Link, useNavigate } from 'react-router-dom';
import { api_getBannersByBannerGroupName } from '~/backend/api_calls';

const HomepageMotto = () => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const [motto, setMotto] = useState({});
	const groupName = 'HomepageMotto';

	// Runs once after init rendering
	useEffect(() => {
		api_getBannersByBannerGroupName(groupName)
			.then(json => {
				if (json.items.length > 0) setMotto(json.items[0]);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	if (motto.length == 0) return null;

	return (
		<section id="homepage-motto">
			<div className="content-wrapper">
				<h2 className="motto-title">
					<div className="hashtag">
						<svg xmlns="http://www.w3.org/2000/svg" width="36" height="56" viewBox="0 0 36 56">
							<text
								id="_"
								data-name="#"
								transform="translate(1 46)"
								fill="none"
								stroke="#000"
								strokeWidth="1"
								fontSize="48"
								fontFamily="Ubuntu-Bold, Ubuntu"
								fontWeight="700">
								<tspan x="0" y="0">
									#
								</tspan>
							</text>
						</svg>
					</div>
					{motto.tl}
				</h2>
				<div dangerouslySetInnerHTML={{ __html: motto.bd }} />
				{motto.nu ? (
					<Link to={motto.nu} className="motto-link">
						{t('homepage_motto_history')}
						{/*<div className="arrow">*/}
						{/*    <svg xmlns="http://www.w3.org/2000/svg" width="12.379" height="12.69" viewBox="0 0 12.379 12.69">*/}
						{/*        <g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(-4.5 -6.97)">*/}
						{/*            <path id="Path_38024" data-name="Path 38024" d="M7.5,18H19.129" transform="translate(-3 -4.685)" fill="none" stroke="#000" strokeLinejoin="round" strokeWidth="1.5" />*/}
						{/*            <path id="Path_38025" data-name="Path 38025" d="M18,7.5l5.815,5.815L18,19.129" transform="translate(-7.685)" fill="none" stroke="#000" strokeLinejoin="round" strokeWidth="1.5" />*/}
						{/*        </g>*/}
						{/*    </svg>*/}
						{/*</div>*/}
					</Link>
				) : null}
			</div>
		</section>
	);
};

export default HomepageMotto;
